<template>
  <div class="collect">
    <Header :title="{ name: '学习轨迹' }" :goBackHandler="goBack"></Header>
    <!-- <Empty
      :empty_type="{ name: '暂无轨迹' }"
      v-if="list.length == 0"
      style="margin-top:20vw;"
    ></Empty> -->
    <div class="content">
      <div class="card1 shadow">
        <p class="title">
          <img src="@/assets/images/path_study_icon.png">
          <span>学习时长统计</span>
        </p>
        <ul class="card_item_ul">
          <li class="card_item_li first_item">
            <span class="num">{{$pub.formatSeconds(data.study.today_time)}}</span>
            <span class="lable">昨日学习</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{$pub.formatSeconds(data.study.week_time)}}</span>
            <span class="lable">本周学习</span>
          </li>
          <li class="card_item_li last_item">
            <span class="num">{{$pub.formatSeconds(data.study.total_time)}}</span>
            <span class="lable">累计学习</span>
          </li>
        </ul>
        <ul class="card_item_ul">
          <li class="card_item_li first_item">
            <span class="num">{{$pub.formatSeconds(data.study.live_time)}}</span>
            <span class="lable">直播课学习时长</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{data.study.live_study_percent}}</span>
            <span class="lable">直播出勤率</span>
          </li>
          <li class="card_item_li last_item">
            <span class="num">{{$pub.formatSeconds(data.study.play_time)}}</span>
            <span class="lable">录播课观看时长</span>
          </li>
        </ul>
      </div>
      <div class="card2 shadow">
        <p class="title">
          <img src="@/assets/images/path_ques_icon.png">
          <span>问答统计</span>
        </p>
        <ul class="card_item_ul">
          <li class="card_item_li first_item">
            <span class="num">{{data.ask.ask_count}}</span>
            <span class="lable">提问数量</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{data.ask.collected_count}}</span>
            <span class="lable">被收藏数量</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{data.ask.praise_count}}</span>
            <span class="lable">点赞数量</span>
          </li>
          <li class="card_item_li last_item">
            <span class="num">{{data.ask.collect_count}}</span>
            <span class="lable">收藏问答量</span>
          </li>
        </ul>
      </div>
      <div class="card3 shadow">
        <p class="title">
          <img src="@/assets/images/path_checkin_icon.png">
          <span>打卡统计</span>
        </p>
        <ul class="card_item_ul">
          <li class="card_item_li first_item">
            <span class="num">{{data.exam.total_days}}</span>
            <span class="lable">打卡天数</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{data.exam.question_count}}</span>
            <span class="lable">做题总数量</span>
          </li>
          <li class="card_item_li last_item">
            <span class="num">{{data.exam.right_percent}}</span>
            <span class="lable">正确率</span>
          </li>
        </ul>
      </div>
      <div class="card4 shadow">
        <p class="title">
          <img src="@/assets/images/path_exercise_icon.png">
          <span>练习统计</span>
        </p>
        <ul class="card_item_ul">
          <li class="card_item_li first_item">
            <span class="num">{{data.questions.total_count}}</span>
            <span class="lable">做题总数量</span>
          </li>
          <li class="card_item_li">
            <span class="num">{{data.questions.error_count}}</span>
            <span class="lable">错题总数</span>
          </li>
          <li class="card_item_li last_item">
            <span class="num">{{data.questions.right_percent}}</span>
            <span class="lable">正确率</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
export default {
  name: "collect",
  components: {
    Header,
    Empty
  },
  data() {
    return {
      data: {
        study: {
          today_time: 0,
          week_time: 0,
          total_time: 0,
          live_study_percent: 0,
          live_time: 0,
          play_time: 0,
        },
        exam: {
          question_count: 0,
          right_percent: 0,
          total_days: 0,
        },
        ask: {
          ask_count: 0,
          collect_count: 0,
          collected_count: 0,
          praise_count: 0,
        },
        questions: {
          error_count: 0,
          right_percent: 0,
          total_count: 0
        }
      }
    };
  },
  created() {
    this.goData();
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    goData() {
      this.$http
        .get(`/api/app/study/statistics`)
        .then((res) => {
          this.data = res
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.collect {
  @extend %default-bg;
  background-color: #f6f6f6;
  font-family:PingFang SC;
  .content {
    .shadow{
      width:620px;
      margin: 30px auto;
      background:#fff;
      box-shadow:0px 0px 10px 0px rgba(56,56,56,0.1);
      border-radius:20px;
      padding: 31px 36px;
      .title{
        color: #333;
        font-size: 30px;
        height: 62px;
        line-height: 62px;
        img{
          margin-right: 17px;
          vertical-align: middle;
        }
      }
    }
    .card1{
      height:298px;
      img{
        width: 29px;
        height: 27px;
      }
    }
    .card_item_ul{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .card_item_li{
        height: 100px;
        line-height: 40px;
        text-align: center;
        width: 40%;
        .num{
          font-size: 32px;
          color: #222222;
          display: block;
          font-weight:600;
        }
        .lable{
          color: #999999;
          font-size: 24px;
        }
      }
      .first_item{
        width: 30%;
      }
      .last_item{
        width: 30%;
      }
    }
    .card2,.card3{
      height:200px;
      img{
        width: 38px;
        height: 30px;
      }
      .card_item_ul{
        margin-top: 50px;
        .card_item_li{
          width: 25%;
        }
      }
    }
    .card3{
      img{
        width: 32px;
        height: 32px;
        margin-top: -5px;
      }
    }
    .card4{
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
